import { nbspToSpace } from './helpers'

const replaceNbspInDataEvent = (evt: CKEDITOR.eventInfo) => {
  const dataValue = evt?.data?.dataValue

  if (typeof dataValue !== 'string') {
    return
  }

  evt.data.dataValue = nbspToSpace(dataValue)
}

const handleKeyEditor = (evt: CKEDITOR.eventInfo) => {
  if (evt.data.domEvent?.$?.code !== 'Space') {
    return
  }

  if (!evt.editor.getSelection()?.getRanges()?.length) {
    return
  }

  evt.cancel()
  evt.editor.insertText(' ')
}

export const nbspToSpacePlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    editor.on('key', handleKeyEditor, null, null, 0)
    editor.on('paste', replaceNbspInDataEvent, null, null, 0)
    editor.on('getData', replaceNbspInDataEvent, null, null, 0)
    editor.on('setData', replaceNbspInDataEvent, null, null, 0)
  },
}
